import { render, staticRenderFns } from "./vietnamScccess.vue?vue&type=template&id=d6096066&scoped=true&"
import script from "./vietnamScccess.vue?vue&type=script&lang=ts&"
export * from "./vietnamScccess.vue?vue&type=script&lang=ts&"
import style0 from "./vietnamScccess.vue?vue&type=style&index=0&id=d6096066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6096066",
  null
  
)

export default component.exports